import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";

// // // //

export const ID_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> = {
    slug: AssetColumns.id,
    label: "ID",
    type: ColumnTypes.number,
    sortsOn: AssetColumns.id,
    width: 100,
    render: (item) => {
        if (typeof item.id !== "number") {
            return <Emdash />;
        }

        return <span className="font-mono">{item.id}</span>;
    },
};
